var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalleryicon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7071 11.2929C28.0976 11.6834 28.0976 12.3166 27.7071 12.7071L22.2071 18.2071C21.8166 18.5976 21.1834 18.5976 20.7929 18.2071C20.4024 17.8166 20.4024 17.1834 20.7929 16.7929L26.2929 11.2929C26.6834 10.9024 27.3166 10.9024 27.7071 11.2929Z",
    fill: "#101828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7929 12.7929C14.1834 12.4024 14.8166 12.4024 15.2071 12.7929L19.2071 16.7929C19.5976 17.1834 19.5976 17.8166 19.2071 18.2071C18.8166 18.5976 18.1834 18.5976 17.7929 18.2071L13.7929 14.2071C13.4024 13.8166 13.4024 13.1834 13.7929 12.7929Z",
    fill: "#101828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2071 12.7929C12.5976 13.1834 12.5976 13.8166 12.2071 14.2071L5.70711 20.7071C5.31658 21.0976 4.68342 21.0976 4.29289 20.7071C3.90237 20.3166 3.90237 19.6834 4.29289 19.2929L10.7929 12.7929C11.1834 12.4024 11.8166 12.4024 12.2071 12.7929Z",
    fill: "#101828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 10C28.2239 10 28 10.2239 28 10.5C28 10.7761 28.2239 11 28.5 11C28.7761 11 29 10.7761 29 10.5C29 10.2239 28.7761 10 28.5 10ZM26 10.5C26 9.11929 27.1193 8 28.5 8C29.8807 8 31 9.11929 31 10.5C31 11.8807 29.8807 13 28.5 13C27.1193 13 26 11.8807 26 10.5Z",
    fill: "#101828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 18.5C19.7239 18.5 19.5 18.7239 19.5 19C19.5 19.2761 19.7239 19.5 20 19.5C20.2761 19.5 20.5 19.2761 20.5 19C20.5 18.7239 20.2761 18.5 20 18.5ZM17.5 19C17.5 17.6193 18.6193 16.5 20 16.5C21.3807 16.5 22.5 17.6193 22.5 19C22.5 20.3807 21.3807 21.5 20 21.5C18.6193 21.5 17.5 20.3807 17.5 19Z",
    fill: "#101828"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 11.5C12.7239 11.5 12.5 11.7239 12.5 12C12.5 12.2761 12.7239 12.5 13 12.5C13.2761 12.5 13.5 12.2761 13.5 12C13.5 11.7239 13.2761 11.5 13 11.5ZM10.5 12C10.5 10.6193 11.6193 9.5 13 9.5C14.3807 9.5 15.5 10.6193 15.5 12C15.5 13.3807 14.3807 14.5 13 14.5C11.6193 14.5 10.5 13.3807 10.5 12Z",
    fill: "#101828"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 21C3.22386 21 3 21.2239 3 21.5C3 21.7761 3.22386 22 3.5 22C3.77614 22 4 21.7761 4 21.5C4 21.2239 3.77614 21 3.5 21ZM1 21.5C1 20.1193 2.11929 19 3.5 19C4.88071 19 6 20.1193 6 21.5C6 22.8807 4.88071 24 3.5 24C2.11929 24 1 22.8807 1 21.5Z",
    fill: "#101828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryicon2);
export default __webpack_public_path__ + "static/media/galleryicon2.5481278b3669f2c4b5e40a7d355f3f22.svg";
export { ForwardRef as ReactComponent };